export default __webpack_public_path__ + "static/media/screen-art-magazine-min.3af5f3fd.png";